import { loginUser, logoutUser } from '@store/reducers/auth';
import { useEffect, useState } from 'react';
import { Loader } from 'react-clip-loader';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Links } from '../../helpers/Links';
import { casService } from '../../helpers/login';
import * as AuthService from '../../services/auth';
import { removeMenu } from '../../store/reducers/menu';

const LoginSSO = () => {
    const [showMessage, setShowMessage] = useState(false);
    const dispatch = useDispatch();

    const navigate = useNavigate();
    const [t] = useTranslation();

    const loginSSO = async (serviceURL: string, ticket: string) => {
        try {
            const info = await AuthService.loginSSO(serviceURL, ticket);
            toast.success('Đăng nhập thành công!');
            dispatch(loginUser(info));
            navigate('/');
        }
        catch (error: any) {
            if (error.response.status === 400) {
                casService.loginSSO(Links.CasService.CasClient);
            }

            if (error.response.status === 404) {
                setShowMessage(true);
            }
            dispatch(removeMenu());
            dispatch(logoutUser());
        }
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        var ticket = params.get('ticket') || '';
        var serviceURL = encodeURIComponent(window.location.origin + Links.CasService.CasClient);
        loginSSO(serviceURL, ticket);
    }, []);

    return (<section>
        {
        !showMessage ?
            <Loader small={true} color={'#2d4059'} secondaryColor={'#e5e5e5'} /> :
            <div className="hold-transition login-page" style={{ background: "url(/slider/slider1.jpg) center" }}>
                <div className="login-box" style={{ width: "auto" }}>
                    <div className="card card-outline card-primary">
                        <div className="card-header text-center">
                            <Link to="/" className="h1">
                                <p><b>DDIF HRM</b></p>
                            </Link>
                        </div>
                            {showMessage ?
                                <div className="login-box-body">
                                    <p className="login-box-msg"><b>Tài khoản này không có quyền truy cập vào ứng dụng.</b></p>
                                    <p className="login-box-msg"><b>Vui lòng kiểm tra lại.</b></p>
                                    <br />
                                    <a className="a-login" href="#" onClick={() => { casService.logoutSSO(Links.CasService.CasClient); }}><p className="login-box-msg">Đăng nhập tài khoản khác.</p></a>
                                </div> : null}
                    </div>
                </div>
            </div>
    }
    </section>);
};

export default LoginSSO;
